import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as OnboardingSuccessSvg } from '../../../assets/img/onboarding-success.svg'

const iconEnter = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.88);
    }
    65% {
        opacity: 1;
        transform: scale(1.04);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`

const checkDraw = keyframes`
    from {
        stroke-dashoffset: 42;
        opacity: 0.7;
    }
    to {
        stroke-dashoffset: 0;
        opacity: 1;
    }
`

const starPop = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.4);
    }
    35% {
        opacity: 1;
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`

const AnimatedSuccessIcon = styled(OnboardingSuccessSvg)`
    animation: ${iconEnter} 780ms ease-out both;
    transform-origin: center;

    .success-check {
        stroke-dasharray: 42;
        stroke-dashoffset: 42;
        animation: ${checkDraw} 680ms ease-out 280ms forwards;
    }

    .success-star {
        opacity: 0;
        transform-box: fill-box;
        transform-origin: center;
        animation: ${starPop} 620ms ease-out forwards;
    }

    .success-star-1 {
        animation-delay: 420ms;
    }

    .success-star-2 {
        animation-delay: 540ms;
    }

    .success-star-3 {
        animation-delay: 660ms;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;

        .success-check,
        .success-star {
            animation: none;
            opacity: 1;
            stroke-dashoffset: 0;
        }
    }
`

const OnboardingSuccessIcon: React.FC = () => <AnimatedSuccessIcon aria-hidden />

export default OnboardingSuccessIcon
